// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  //ApiUrl: 'https://admin.hopetoshine.in/WVI/',
  ApiUrl: 'https://joytogiveuat.worldvision.org.ph',
  WebUrl: 'https://www.hopetoshine.in/',
  ApiUrlPdf: 'https://admin.hopetoshine.in',

  GTM_ID: 'GTM-P9DKB7H',

  CCA_MERCHANTID: '411',
  CCA_ACCESSCODE: 'AVOJ81FK91CE30JOEC',
  CCA_REQUEST_URL: 'https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction',
  CCA_ENCRYPTION_KEY: '626FCA3B776D706457BA74AF84F81518',

  CCAFCRA_MERCHANTID: '411',
  CCAFCRA_ACCESSCODE: 'AVOJ81FK91CE30JOEC',
  CCAFCRA_ENCRYPTION_KEY: '626FCA3B776D706457BA74AF84F81518',

  AXIS_ACCESSCODE: 'KMPM5022',
  AXIS_REQUEST_URL: 'https://geniusepay.in/VAS/DCC/do.action',
  AXIS_ENCRYPTION_KEY: '5FCBDE0D45FD4C614EDD4970BA065105',
  AXIS_SECURE_SECRET: '002B56EE2153C809811685575A012D10',

  HDFC_REQUEST_URL: 'oauth/SendPerformREQuest.aspx'
};

//UAT 

// export const environment = {
//   production: false,
//   ApiUrl: 'https://adminuat.hopetoshine.in/WVI/',
//   WebUrl: 'https://websiteuat.hopetoshine.in/',
//   ApiUrlPdf: 'https://adminuat.hopetoshine.in',

//   CCA_MERCHANTID: '111657',
//   CCA_ACCESSCODE: 'AVRI02FK39CE08IREC',
//   CCA_REQUEST_URL: 'https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction',
//   CCA_ENCRYPTION_KEY: '14BDBFF7B4C5B79809C60BD6FBFCCA8F',

//   CCAFCRA_MERCHANTID: '411',
//   CCAFCRA_ACCESSCODE: 'AVOJ81FK91CE30JOEC',
//   CCAFCRA_ENCRYPTION_KEY: '626FCA3B776D706457BA74AF84F81518',

//   AXIS_ACCESSCODE: 'BPLI5291',
//   AXIS_REQUEST_URL: 'https://uat-geniusepay.in/VAS/DCC/doEnc.action',
//   AXIS_ENCRYPTION_KEY: 'D9B30F419411CFBB9D19889C66929003',
//   AXIS_SECURE_SECRET: 'E9DFEA56BDFBC5CB9F199A103E0C4CCD',
//   HDFC_REQUEST_URL: 'oauth/SendPerformREQuest.aspx'
// };

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
